import { twMerge as twm } from 'tailwind-merge'

import Check from '../../../icons/check.svg?react'

type Props = {
    style?: 'checkbox' | 'radio'
    isChecked?: boolean
    onChange?: (newIsChecked: boolean) => void
    disabled?: boolean
    className?: string
    size?: 'sm' | 'md'
}

export const Checkbox = ({
    style = 'checkbox',
    isChecked = false,
    disabled = false,
    onChange = () => {},
    className,
    size,
}: Props) => {
    const handleClick = (event: React.MouseEvent) => {
        if (disabled) {
            return
        }

        event.stopPropagation()
        event.preventDefault()
        onChange(!isChecked)
    }

    return (
        <button
            className={twm(
                'flex size-6 items-center justify-center border-2',
                size === 'sm' ? 'size-5' : 'size-6',
                style === 'checkbox' ? 'rounded-sm' : 'rounded-full',
                isChecked ? 'border-secondary-400' : 'border-gray-500 bg-white',
                isChecked && (style === 'checkbox' ? 'bg-secondary-400' : 'bg-white'),
                !isChecked && !disabled && 'hover:border-secondary-400',
                disabled && 'cursor-default opacity-40',
                className
            )}
            onClick={handleClick}
        >
            {isChecked &&
                (style === 'checkbox' ? (
                    <Check className="size-4" />
                ) : (
                    <div className="bg-secondary-400 size-3 rounded-full" />
                ))}
        </button>
    )
}
